import { render } from "./ClientPicker.vue?vue&type=template&id=2b8c6441&scoped=true"
import script from "./ClientPicker.vue?vue&type=script&lang=js"
export * from "./ClientPicker.vue?vue&type=script&lang=js"

import "./ClientPicker.vue?vue&type=style&index=0&id=2b8c6441&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8c6441"]])

export default __exports__